import styled from "styled-components";

export const StyledGlobalCreateButtonDiv = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;

  > svg {
    display: block;
    width: 18px;
    height: 18px;
  }
`;
